import { render } from "./EconomicIndicatorForm.vue?vue&type=template&id=7a6c4ad3&scoped=true"
import script from "./EconomicIndicatorForm.vue?vue&type=script&lang=js"
export * from "./EconomicIndicatorForm.vue?vue&type=script&lang=js"

import "./EconomicIndicatorForm.vue?vue&type=style&index=0&id=7a6c4ad3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6c4ad3"]])

export default __exports__